import { DispatchEventDetails, DispatchEvents } from '@btcdirect/shared/src/types';

/**
 * Dispatch a custom event. Used to communicate messages higher than the widget.
 *
 * @param name
 * @param values
 */
export function dispatch(name: DispatchEvents, values?: DispatchEventDetails) {
    const event = new CustomEvent(name, { bubbles: true, composed: true, detail: values ?? null });
    dispatchEvent(event);
}
